module.exports = __webpack_public_path__ + "img/users-2-svgrepo-com.c1105613.svg";